import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";
import { SxProps } from "@mui/material";
import { StatusSize } from "./status";

export const statusVariantStyleMap = {
  primary: {
    backgroundColor: nawyTheme.nawy.colors.semantic.layer.accent,
    color: nawyTheme.nawy.colors.semantic.text.onColor,
  },
};

export const sizeStyles = new Map<StatusSize, SxProps>([
  [
    "lg",
    {
      height: nawyTheme.nawy.spacing.xl,
      padding: `0 ${nawyTheme.nawy.spacing.sm}`,
      fontSize:
        nawyTheme.nawy.typography.english.variants.body.md.regular.fontSize,
      fontWeight:
        nawyTheme.nawy.typography.english.variants.body.md.regular.fontWeight,
      lineHeight:
        nawyTheme.nawy.typography.english.variants.body.md.regular.lineHeight,
      gap: nawyTheme.nawy.spacing.xs,
    },
  ],
  [
    "md",
    {
      height: nawyTheme.nawy.spacing.lg,
      padding: `0 ${nawyTheme.nawy.spacing.xs}`,
      fontSize:
        nawyTheme.nawy.typography.english.variants.body.sm.regular.fontSize,
      fontWeight:
        nawyTheme.nawy.typography.english.variants.body.sm.regular.fontWeight,
      lineHeight:
        nawyTheme.nawy.typography.english.variants.body.sm.regular.lineHeight,
      gap: nawyTheme.nawy.spacing.xxs,
    },
  ],
  [
    "sm",
    {
      height: "20px",
      padding: `0 ${nawyTheme.nawy.spacing.xxs}`,
      fontSize:
        nawyTheme.nawy.typography.english.variants.body.xs.regular.fontSize,
      fontWeight:
        nawyTheme.nawy.typography.english.variants.body.xs.regular.fontWeight,
      lineHeight:
        nawyTheme.nawy.typography.english.variants.body.xs.regular.lineHeight,
      gap: nawyTheme.nawy.spacing.xxs,
    },
  ],
]);

export const iconSizes = new Map<StatusSize, number>([
  ["lg", 18],
  ["md", 16],
  ["sm", 14],
]);
